import React from 'react'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import * as styles from './PropertyDetailFrame.module.scss'

import {
  ActivitySearchPanel,
  Layout,
  News,
  Notification,
  PropertyDetail,
  PropertySearchPanel,
  ReservationButton,
  SlideShow,
} from '../../components'
import { PATH } from '../../constants'
import {
  useCreateNextPath,
  useHotelNewsApi,
  useNotificationsApi,
  usePropertyProvider,
} from '../../hooks'

export const PropertyDetailFrame: React.FC = () => {
  const { data: notifications } = useNotificationsApi()
  const navigate = useNavigate()
  const { params, onCreateNextPath } = useCreateNextPath()
  const { images, isHotel } = usePropertyProvider()
  const { data: news } = useHotelNewsApi(params.property)

  return (
    <Layout>
      <div className={styles.topBannerArea}>
        {images && images.length > 0 && (
          <React.Fragment>
            <div className={styles.sp}>
              <SlideShow
                bordered={false}
                items={images}
                renderItem={(item, i) => (
                  <img
                    src={item.url}
                    alt={`Slide ${i + 1}`}
                    className={styles.slideImage}
                  />
                )}
              />
            </div>
            <div className={clsx(styles.pc, styles.pcHero)}>
              <SlideShow
                bordered={false}
                items={images}
                renderItem={(item, i) => (
                  <img
                    src={item.url}
                    alt={`Slide ${i + 1}`}
                    className={styles.slideImage}
                  />
                )}
              />
            </div>
          </React.Fragment>
        )}
        <div className={styles.propertySearchPanel}>
          {isHotel ? (
            <PropertySearchPanel
              showNumberOfGuestsSearch
              onSearch={({
                schedule: { endDate, startDate } = {},
                numberOfGuests,
              }) => {
                navigate(
                  onCreateNextPath(PATH.rooms, {
                    pathParams: {
                      room: params.room,
                    },
                    queryParams: {
                      checkInDate: startDate,
                      checkOutDate: endDate,
                      numberOfAdults: numberOfGuests?.adults,
                      numberOfChildren: numberOfGuests?.children,
                      numberOfInfants: numberOfGuests?.infants,
                    },
                  })
                )
              }}
            />
          ) : (
            <ActivitySearchPanel
              onSearch={({ checkInDate, numberOfGuests }) => {
                navigate(
                  onCreateNextPath(PATH.rooms, {
                    pathParams: {
                      room: params.room,
                    },
                    queryParams: {
                      checkInDate,
                      checkOutDate: checkInDate,
                      numberOfAdults: numberOfGuests?.adults,
                      numberOfChildren: numberOfGuests?.children,
                      numberOfInfants: numberOfGuests?.infants,
                    },
                  })
                )
              }}
            />
          )}
        </div>
      </div>
      {((notifications && notifications?.length > 0) ||
        (news && news?.contentJa)) && (
        <div className={styles.centerArea}>
          <div className={styles.notificationArea}>
            {notifications && notifications.length > 0 && (
              <Notification notifications={notifications} />
            )}
            {news && news.contentJa && <News news={news} />}
          </div>
        </div>
      )}
      <PropertyDetail />
      <ReservationButton propertySlug={params.property || ''} />
    </Layout>
  )
}
